import {MatchLineupsAction, MatchLineupsState} from './types';
import {MatchDetailCleanup} from '../matchDetail/types';
import {
  MATCH_LINEUPS_BY_EVENT_ID_GET_INVALIDATE,
  MATCH_LINEUPS_BY_EVENT_ID_GET_REQUEST,
  MATCH_LINEUPS_BY_EVENT_ID_GET_RESPONSE,
  MATCHDETAIL_CLEANUP,
} from '../actionTypes';


const initialState: MatchLineupsState = {
  isFetching: false,
  didInvalidate: false,
};

/**
 * Derives the 'matchLineup' state by reducing a new one every time an involved action is dispatches.
 * If the action is not involved (meaning it's not related with this state), then the state
 * is not changed.
 * @param state
 * @param action
 */
const matchLineupsReducer = (state: MatchLineupsState = initialState, action: MatchLineupsAction | MatchDetailCleanup): MatchLineupsState => {
  switch (action.type) {
    case MATCH_LINEUPS_BY_EVENT_ID_GET_REQUEST:
      return ({
        ...state,
        isFetching: true,
        error: undefined,
      });
    case MATCH_LINEUPS_BY_EVENT_ID_GET_RESPONSE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: false,
        data: action.payload.data,
      });
    case MATCH_LINEUPS_BY_EVENT_ID_GET_INVALIDATE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.error,
      });
    case MATCHDETAIL_CLEANUP:
      return {...initialState};
    default:
      return state;
  }
};

export default matchLineupsReducer;
